import * as types from './mutations-types'
import cancelCouponApi from '../../../../api/wx-member/cancel-coupon/cancel-coupon'
import * as DataTypeConstants from '../../../../constants/DataTypeConstants'
import * as DictionaryConstants from '../../../../constants/DictionaryConstants'
import FormatTableFieldUtils from '../../../../common/utils/format-table-field-util'
import dictApi from '../../../../api/dict/dictionary-api'

export default {
  getCancelRecord: ({ commit }, data) => {
    cancelCouponApi.getCancelRecord(data)
      .then(result => {
        let params = [
          {
            fieldDataType: DataTypeConstants.FORMAT_TABLE_DICT,
            fieldPropCode: 'couponType',
            fieldPropName: 'couponTypeName',
            fieldFormatParam: DictionaryConstants.COUPON_CUPON_TYPE
          }
        ]
        FormatTableFieldUtils.formatTableFieldName(result.dataList, params).then(res => {
          result = res
          commit(types.CANCEL_RECORD_LIST, result)
        })
      })
  },
  updateCouponRecord: ({ commit }, data) => {
    commit(types.UPDATE_COUPON_INFO_RECORD, data)
  },
  updateCouponFalseRecord: ({ commit }, data) => {
    commit(types.UPDATE_COUPON_INFO_FALSE_RECORD, data)
  },
  getStaff: ({ commit, state }, dictCode) => {
    dictApi.getReservationCustomerByCode(dictCode)
      .then(res => {
        commit(types.STAFF_INFO, res)
      })
  },
  commitApplication: ({ commit }, data) => {
    return new Promise(resolve => {
      cancelCouponApi.commitApplication(data)
        .then(result => {
          resolve(result)
        })
    })
  },
  getMemberAppointmentInfo: ({ commit }, data) => {
    cancelCouponApi.getMemberAppointmentInfo(data)
      .then(result => {
        commit(types.MEMBER_APPOINTMENT_DATA, result)
      })
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/cancel-coupon/store/actions.js